<template>
  <div class="kpi-brand-staff-page">
    <van-tabs
      v-model="typeIndex"
      title-active-color="#3283fa"
      color="#3283fa"
      :sticky="true"
      :swipe-threshold="2"
      @change="setType"
    >
      <van-tab class="list" v-for="(type, key) in types" :key="type.title" :title="type.title">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="— 暂无更多数据 —"
          :offset="1"
          :immediate-check="false"
          @load="onLoad"
          class="list"
        >
          <div class="item bottom-line" v-for="(item, index) in ShowList" :key="index">
            <div class="title brand">
              <img
                v-if="typeIndex==0"
                class="staff-img"
                :src="item.brandLogo ? item.brandLogo : 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"
                alt
              />
              <img
                v-if="typeIndex==1"
                class="staff-img"
                :src="item.avatar ? item.avatar : 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"
                alt
              />
              <span class="name">{{item.name}}</span>
            </div>
            <div>
              <van-button
                round
                plain
                class="done"
                size="small"
                v-if="item.recharged==='true'||item.recharged===true"
              >已充值</van-button>
              <van-button
                round
                plain
                type="danger"
                size="small"
                v-if="item.recharged==='false'||item.recharged===false"
              >未充值</van-button>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activity: {},
      // user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      user: null,
      kpi_user: null,
      page: 1,
      loading: false,
      finished: false,
      typeIndex: 0,
      types: [{ title: "参与品牌" }, { title: "参与导购员" }],
      list: [],
      ShowList: [],
      ShowListTotal: 0,
      count: 0, //总条数
      nowpage: 1, //当前页
    };
  },
  computed: {
    type() {
      return this.typeIndex + 1;
    },
  },
  created() {
    this.getBrandList();
    // this.getStaffList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取参与的品牌列表
    async getBrandList() {
      var actId = localStorage.getItem("act_id");
      let res = await this.$http.post(`/v1/taskmanage/list`, {
        actId: actId,
        catId: "",
        name: "",
        page: this.nowpage,
        size: 10,
      });
      console.log(res);
      if (res.data && res.code == 0) {
        var list = res.data.list;
        // 下拉判断
        if (this.nowpage === 1) {
          this.ShowList = list || [];
        } else {
          this.ShowList = this.ShowList.concat(list);
        }
        this.count = res.data.total;
      }
    },
    async getStaffList() {
      var actId = localStorage.getItem("act_id");
      let res = await this.$http.post(`/v1/taskmanage/query_kpi_user_list`, {
        actId: actId,
        page: this.nowpage,
        size: 10,
        type: "staff",
      });
      console.log(res);
      if (res.data && res.code == 0) {
        var list = res.data.list;
        // 下拉判断
        if (this.nowpage === 1) {
          this.ShowList = list || [];
        } else {
          this.ShowList = this.ShowList.concat(list);
        }
        this.count = res.data.total;
      }
    },

    setType(index) {
      this.ShowList = [];
      this.count = 0;
      this.loading = false;
      this.finished = false;
      this.nowpage = 1;
      this.list = [];
      if (this.typeIndex == 1) {
        this.getStaffList();
      } else {
        this.getBrandList();
      }
    },
    onLoad() {
      console.log(233);
      // 获取当前的总条数，当前页数。
      // 如果条数除以10向上取整，大于当前页数，则执行一次加载
      if (Math.ceil(this.count / 10) > this.nowpage) {
        this.nowpage = this.nowpage + 1;
        if (this.typeIndex == 1) {
          this.getStaffList();
        } else {
          this.getBrandList();
        }
      } else {
        if (this.nowpage != 1) {
          this.finished = true;
        }
      }
      this.loading = false;
    },
    /**
     * 获取用户信息
     */
    getUser() {
      this.$fn.get("user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "error") {
          return this.$fn.fail(res.msg);
        }
        this.user = res.data; // type: 3--导购员  type: 2--品牌负责人 type: 1--活动负责人
        this.getKpiUser();
      });
    },
    getKpiUser() {
      this.$fn.get("kpi/user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "error") {
          return this.$fn.fail(res.msg);
        }
        this.kpi_user = res.data; // type: 3--导购员  type: 2--品牌负责人 type: 1--活动负责人
        this.$fn.commonShare(this.activity, this.user, this.kpi_user);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.kpi-brand-staff-page {
  .list {
    margin-top: 10px;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #ffffff;
      padding: 10px 15px;
      .title {
        display: flex;
        align-items: center;
        .name {
          font-weight: bold;
        }
      }
    }
    img {
      width: 60px;
      min-width: 60px;
      max-width: 60px;
      height: 45px;
      vertical-align: bottom;
      margin-right: 10px;
    }
    .brand-img {
      border-radius: 4px;
    }
    .staff-img {
      width: 45px !important;
      min-width: 45px;
      max-width: 45px;
      border-radius: 50%;
    }
    /deep/.van-button--small {
      height: 26px;
      min-width: 70px;
      line-height: 24px;
    }
    .done {
      border: 1px solid #999999;
      color: #999999;
      box-sizing: border-box;
    }
  }
}
</style>
